import { goFetch } from "@/utils/network-utils";
import { ApplicationAlertApiResponse as ApplicationAlertDto, ApplicationAlertQuery } from "@/types/api/fetch";
import type { ApplicationAlert as ApplicationAlertEntity } from "@/types/entities";
import { ApplicationId } from "@/constants";
import { DateTime } from "luxon";

function toEntity( input: ApplicationAlertDto ): ApplicationAlertEntity {
    return {
        id: input.id,
        type: input.type.toLocaleLowerCase(),
        description: input.description,
        severity: input.severity,
        status: input.status.toLocaleLowerCase(),
        isResolved: input.isResolved,
        startDateTime: DateTime.fromISO( input.startDateTimeUTC ),
        statusUpdatedDateTime: DateTime.fromISO( input.statusUpdatedDateTimeUTC ),
        details: input.details,
        affectedVersion: input.affectedVersion
    };
}

export async function getApplicationAlerts( authToken: string | null, types: string[] | null ): Promise<ApplicationAlertEntity[]> {
    try {
        const response =
            await goFetch<ApplicationAlertDto, ApplicationAlertQuery>(
                {
                    endpoint: 'ux/graphql',
                    authToken: authToken,
                    payload: {
                        id: 'a678a487a69c45aba79d78eefd555839',
                        variables:
                            {
                                filter:
                                    {
                                        applicationId: ApplicationId,
                                        maxResolvedAgeDays: 60,
                                        types: types
                                    }
                            }
                    }
                } );

        return response?.data?.applicationAlerts?.map( ( p: ApplicationAlertDto ) => toEntity( p ) ) ?? [];
    } catch {
        return [];
    }
}
